import { useEffect, useState } from 'react';
import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';

export default function useGalleryStats(activationId: number) {
    const authenticatedApi = useAuthenticatedApi();
    const [totalPhotos, setTotalPhotos] = useState(0);
    const [lastPhotoTaken, setLastPhotoTaken] = useState<string | null>(null);
    const [moderationToken, setModerationToken] = useState<string | null>(null);
    const [slug, setSlug] = useState<string | null>(null);
    const [galleryId, setGalleryId] = useState<number | null>(null);
    const { orgId } = useUserOrg();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getGalleryStats = async () => {
            setIsLoading(true);
            const response = await authenticatedApi.get(
                `/${orgId}/activations/${activationId}/photoStats`,
            );
            const data = response.data;

            try {
                const moderationResponse = await authenticatedApi.get(
                    `/${orgId}/galleries/moderation/${data.galleryId}/token`,
                );

                const moderationData = moderationResponse.data;
                const token = moderationData.token;
                setModerationToken(token);
            } catch (error) {
                const createTokenResponse = await authenticatedApi.post(
                    `/${orgId}/galleries/moderation/${data.galleryId}/token`,
                );

                const createTokenData = createTokenResponse.data;
                const newToken = createTokenData.token;
                setModerationToken(newToken);
            }

            setSlug(data.slug);
            setGalleryId(data.galleryId);
            setTotalPhotos(Number(data.photoCount));
            setLastPhotoTaken(data.lastPhoto?.thumbnail_uri);
            setIsLoading(false);
        };

        getGalleryStats();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId]);

    return {
        totalPhotos,
        lastPhotoTaken,
        isLoading,
        slug,
        galleryId,
        moderationToken,
    };
}
